/* eslint-disable react/require-default-props, react/no-array-index-key, no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import browserHistory from 'react-router/lib/browserHistory';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import size from 'lodash/size';

import ActionItem from './ActionItem';
import getMenu from '../../utils/circles/getMenu';
import ROUTES from '../../constants/routes';
import resolveFamilyMemberOption from '../../utils/converters/resolveFamilyMemberOption';
import { getFamilyMemberRole } from '../../utils/converters/getFamilyMemberRole';
import { PROPS_LIST, CARE_ROLE } from '../../constants/props';
import {
  CIRCLES,
  PROVIDER_PROFILE,
  CIRCLE_PROVIDER,
  TEAM_PROFILE,
  CIRCLE_FAMILY,
} from '../../constants/strings';
import styles from './index.styl';

const providerCircleTypes = [PROVIDER_PROFILE, CIRCLE_PROVIDER];

const onItemClick = ({
  type,
  teamActingUser,
  targetUserId,
  id,
  loggedUserId,
}) => {
  const types = {
    family: 'patient',
    provider: 'provider',
  };
  let subpath = '';

  switch (type) {
    case CIRCLE_FAMILY:
      subpath = ROUTES.FAMILY_MEMBER_PROFILE;
      break;
    case CIRCLE_PROVIDER:
      if (teamActingUser) {
        subpath = ROUTES.TEAM_MEMBER_PROFILE;
      } else {
        subpath = ROUTES.PROVIDER_MEMBER_PROFILE;
      }
      break;
    default:
      subpath = '';
  }

  const path =
    loggedUserId === id
      ? `/profile/${id}/${types[type]}`
      : `/profile/${targetUserId}/${subpath}/${id}`;

  browserHistory.push(path);
};

const checkLastGuardianRole = (list, id, guardian, loggedUserId) => {
  const guardiansList = list.filter(member => {
    return get(member, [CARE_ROLE.GUARDIAN]) || get(member, [CARE_ROLE.PROXY]);
  });

  return size(guardiansList) === 1 && id === loggedUserId && guardian;
};

const getSubtitle = (
  type,
  { role, teamActingUser, organizationName },
  formatMessage,
) => {
  const isProviderCircleType = providerCircleTypes.some(
    circleType => circleType === type,
  );

  if (teamActingUser) return organizationName;
  return isProviderCircleType || type === TEAM_PROFILE
    ? role
    : role && resolveFamilyMemberOption({ role }, formatMessage);
};

const CircleList = ({
  targetUserId,
  loggedUserId,
  isLoggedUser,
  isCaregiver,
  isVerifiedDependent,
  list,
  type,
  children,
  removeFromCircle,
  removeCaregiverRole,
  openInvitePopup,
  openCancelCaregiverInvitePopup,
  intro,
  intl: { formatMessage },
  allowNavigation,
  removeGuardianRole,
  openLeaveCirclePopup,
  title,
  onOpenSimpleFormPopup,
}) => (
  <div>
    <If condition={list.length || !!children}>
      <p styleName="listTitle">
        <If condition={Boolean(title)}>
          {title}
          <Else />
          <FormattedMessage {...CIRCLES.circleTitle} values={{ type }} />
        </If>
      </p>
      <div styleName="list">
        {children}
        {list.map((item, i) => {
          const {
            id,
            displayableName,
            guardian,
            proxy,
            avatar,
            parent,
            teamActingUser,
          } = item;

          const isGuardian = guardian || proxy || parent;
          const isLastGuardian = checkLastGuardianRole(
            list,
            id,
            isGuardian,
            loggedUserId,
          );

          const note = getFamilyMemberRole(item, formatMessage);

          const menu = getMenu({
            formatMessage,
            targetUserId,
            isLoggedUser,
            isCaregiver,
            isVerifiedDependent,
            loggedUserId,
            item,
            type,
            removeFromCircle,
            openInvitePopup,
            openCancelCaregiverInvitePopup,
            removeCaregiverRole,
            removeGuardianRole,
            onOpenSimpleFormPopup,
            openLeaveCirclePopup,
            isLastGuardian,
          });

          const listItem = {
            image: get(avatar, 'thumbMiddle'),
            title: displayableName,
            subtitle: getSubtitle(type, item, formatMessage),
            note,
            titleIcon: teamActingUser ? 'team' : null,
          };

          return (
            <ActionItem
              key={i}
              index={i}
              intro={get(intro, 'assignCaregiver')}
              item={listItem}
              menu={menu}
              onClick={
                allowNavigation
                  ? () =>
                      onItemClick({
                        type,
                        teamActingUser,
                        targetUserId,
                        id,
                        loggedUserId,
                      })
                  : null
              }
            />
          );
        })}
      </div>
    </If>
  </div>
);

CircleList.propTypes = {
  isLoggedUser: PropTypes.bool,
  removeFromCircle: PropTypes.func,
  removeCaregiverRole: PropTypes.func,
  openInvitePopup: PropTypes.func,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.oneOf(PROPS_LIST.circle.type).isRequired,
  targetUserId: PropTypes.number,
  loggedUserId: PropTypes.number,
  isCaregiver: PropTypes.bool,
  intro: PropTypes.shape({
    assignCaregiver: PropTypes.string,
  }),
  children: PropTypes.node,
  openCancelCaregiverInvitePopup: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  allowNavigation: PropTypes.bool,
  isVerifiedDependent: PropTypes.bool,
  removeGuardianRole: PropTypes.func,
  openLeaveCirclePopup: PropTypes.func,
  title: PropTypes.string,
  onOpenSimpleFormPopup: PropTypes.func,
};

export default injectIntl(
  CSSModules(CircleList, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/CircleList/index.jsx